import classes from './CardTab.module.scss';

export const CardTab = ({ title }) => {
    return <div className={classes.cardTabContainer}>{title}</div>;
};
